var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLicenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4119 18.6087V16C28.4119 14.3333 27.4368 11 24.012 11C20.5872 11 19.6121 14.3333 19.6121 16V18.6087M18.5122 27.3043L22.9121 31.6522L29.5119 25.1304M31.6752 21.8696H16.3065C16.0439 21.8696 15.817 22.2663 15.7622 22.5171L13.0122 34.913C12.9384 35.2512 13.2083 36 13.5623 36H34.4618C34.8159 36 35.0606 35.2512 34.9868 34.913C34.9131 34.5752 32.2253 22.5432 32.2195 22.5172C32.2193 22.5164 32.2194 22.5168 32.2192 22.516C32.164 22.2651 31.9374 21.8696 31.6752 21.8696Z",
    stroke: "#333333",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenses);
export default __webpack_public_path__ + "static/media/licenses.2b9527afb9785a39a4abe675ae33b0a6.svg";
export { ForwardRef as ReactComponent };